import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import { observer } from 'mobx-react';

import { Button } from '@this/shared/ui/inputs/button';
import { Input } from '@this/shared/ui/inputs/input';
import { useAITTheme } from '@this/shared/ui/theme';
import type HotelWeight from '@this/domain/hotel_weight';
import { Fetcher, HTTPError } from '@this/src/util';

import Notification from '../../../notification';
import { getStyles } from './repository_display_adjustment.styles';

type Props = {
  weights: HotelWeight[];
};

const HotelWeightsForm: React.FC<Props> = ({ weights }) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const [errors, setErrors] = useState<string[]>([]);

  const updateHotelWeight = async (w: HotelWeight) => {
    setErrors([]);
    try {
      await Fetcher.put(`/admin/repository_display_adjustment/hotel_weights/${w.id}.json`, w.submitParams());
      Notification.success('ホテル表示重み付けを更新しました');
    } catch (e) {
      if (e instanceof HTTPError && e.response?.status === 400) {
        const permissionMessage = e.response.data.message;
        const validationErrors = e.response.data.errors;
        setErrors(validationErrors || [permissionMessage]);
      } else {
        setErrors(['通信エラーが発生しました。時間をおいて再度お試しください。']);
      }
    }
  };

  return (
    <>
      <div style={styles.inlineFormList}>
        {weights.map((w, i) => (
          <form
            key={i}
            style={styles.inlineFormRow}
            onSubmit={e => {
              e.preventDefault();
              updateHotelWeight(w);
            }}
          >
            <label htmlFor={w.key} style={styles.inlineFormLabel}>
              {w.keyText()}
            </label>
            <Input
              id={w.key}
              type="number"
              inputProps={{ step: 0.1 }}
              value={w.weight}
              style={styles.inlineFormInput}
              onChange={e => {
                w.weight = Number(e.target.value);
              }}
            />
            <Button type="submit" color="primary" size="small" style={styles.submitButton}>
              更新
            </Button>
          </form>
        ))}
      </div>
      {!_.isEmpty(errors) &&
        errors.map((e, i) => (
          <p key={i} style={styles.errorText}>
            {e}
          </p>
        ))}
    </>
  );
};

export default observer(HotelWeightsForm);
